import { render, staticRenderFns } from "./WhosShipping.vue?vue&type=template&id=4fa986e5&scoped=true"
import script from "./WhosShipping.vue?vue&type=script&lang=ts"
export * from "./WhosShipping.vue?vue&type=script&lang=ts"
import style0 from "./WhosShipping.vue?vue&type=style&index=0&id=4fa986e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa986e5",
  null
  
)

export default component.exports